export enum CopyBehavior {
    plain = "plain",
    markdown = "markdown"
}

export function getCopyBehaviorFromString(str: string): CopyBehavior {
    return (Object.values(CopyBehavior) as string[]).includes(str) ? (str as CopyBehavior) : CopyBehavior.plain;
}